import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class IncomeReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/report/income")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="container">
            <div className="center-block">
                <div className="row" style={{ "margin-bottom": "20px", "margin-top": "15px" }}>
                    <h4 className="txt-gray text-center txt-bold">صورت سود و زیان</h4>
                    <h5 className="text-muted text-center">{this.state.data.global.company.name}</h5>
                    <div className="text-center">
                        از
                        <input autocomplete="off" id="fromRangeTxt" value="" className="range-from-example text-center" style={{ "border": "solid 1px #ccc" }} />
                        تا
                        <input autocomplete="off" id="toRangeTxt" value="" className="range-to-example text-center" style={{ "border": "solid 1px #ccc" }} />
                        <a className="hand" onClick="getIncomeStateReport()"><i className="fa fa-search"></i></a>
                    </div>
                </div>
                <div className="mr-t-5 text-left">
                    <button className="btn btn-no-frame btn-smoke">
                        <span className="fa fa-print"></span>
                    </button>
                    <button className="btn btn-no-frame btn-smoke">
                        <span className="fa fa-file-pdf-o"></span>
                    </button>
                    <button className="btn btn-no-frame btn-smoke">
                        <span className="fa fa-file-excel-o"></span>
                    </button>
                </div>
                <table className="table table-bordered table-hover m-t-10" id="grid">
                    <thead>
                        <tr className="active txt-bold">
                            <td>شرح</td>
                            <td>مبلغ ({this.state.data.global.company.currencyUnit})</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.other.map(item => <tr>
                            <td style={{ "padding": "5px" }}>{item.accountName}</td>
                            <td style={{ "padding": "5px" }} className="text-center">
                                <span className="red" style={{ "display": "block", "text-align": "center" }}>{this.money(item.price)}</span>
                            </td>
                        </tr>)}
                        <tr className="ng-scope active">
                            <td style={{ "padding": "5px" }}>درآمدها</td>
                            <td style={{ "padding": "5px" }} className="text-center">
                                <span className="ng-hide" id="incomes" style={{ "display": "block", "text-align": "center" }}></span>
                            </td>
                        </tr>
                        {this.state.data.daramad.map(item => <tr>
                            <td style={{ "padding": "5px" }}>{item.accountName}</td>
                            <td style={{ "padding": "5px" }} className="text-center">
                                <span className="red" style={{ "display": "block", "text-align": "center" }}>{this.money(item.price)}</span>
                            </td>
                        </tr>)}
                        <tr className="ng-scope active">
                            <td style={{ "padding": "5px" }}>هزینه ها</td>
                            <td style={{ "padding": "5px" }} className="text-center">
                                <span className="ng-hide" style={{ "display": "block", "text-align": "center" }}></span>
                            </td>
                        </tr>
                        {this.state.data.hazine.map(item => <tr>
                            <td style={{ "padding": "5px" }}>{item.accountName}</td>
                            <td style={{ "padding": "5px" }} className="text-center">
                                <span className="red" style={{ "display": "block", "text-align": "center" }}>{this.money(item.price)}</span>
                            </td>
                        </tr>)}
                        <tr className="info txt-bold">
                            <td style={{ "padding": "5px" }}> سود و زیان خالص</td>
                            <td style={{ "padding": "5px", "direction": "ltr", "text-align": "center" }}>{this.money(this.state.data.sodoZiyanKhales)}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.renderForm(),
                <Footer />
            ];

        return contents;
    }
}